import styled, { css } from 'styled-components/macro';
import { colorAccentInfo200, colorBlackTransparent50, colorCoreBlack900Base, colorCoreGray1000Base, colorCoreGray500, colorCoreWhite1000, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { elevationBottomLvl2 } from '@yme/tokens/elevations';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { fontWeightDefault, fontWeightMedium } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
import { dayContentClassName } from './constants';
import { DatePickerMode } from './types';
const dayContentPseudo = css `
  &::before {
    content: attr(data-value);
    position: absolute;
    height: 100%;
    left: 0px;
    right: 0px;
    top: 0px;
    border-radius: ${CORNER_RADIUS.circle};
    background-color: ${colorCoreBlack900Base};
    display: flex;
    align-items: center;
    justify-content: center;

    ${({ isBottomSheetNeeded }) => isBottomSheetNeeded &&
    css `
        ${ADAPTIVE.maxWidth.tablet} {
          border-radius: ${CORNER_RADIUS.m};
        }
      `}
  }
`;
export const DatePickerCustomStyled = styled.div `
  .rdp {
    --rdp-cell-size: 32px;
    --rdp-background-color: ${colorBlackTransparent50};
    --rdp-accent-color: ${({ mode }) => mode === DatePickerMode.SINGLE ? colorCoreBlack900Base : colorAccentInfo200};

    margin: 0;
  }

  .rdp-months {
    padding: ${INDENT.xs};
    background: ${colorCoreWhite1000};
    border: 1px solid ${colorCoreGray500};
    box-shadow: ${elevationBottomLvl2};
    border-radius: ${CORNER_RADIUS.s};
    user-select: none;
  }

  .rdp-month {
    position: relative;
  }

  .rdp-head_cell {
    ${getTextStyles('Ubuntu', null, 12, 16)};
    ${fontWeightDefault};
    color: ${colorCoreGray1000Base};
    height: --rdp-cell-size;
  }

  .rdp-day {
    border: 0;
    height: --rdp-cell-size;
  }

  .rdp-day_range_middle {
    background-color: ${colorAccentInfo200};
    color: ${colorCoreBlack900Base};
  }

  .rdp-day_today:not(.rdp-day_outside) {
    ${fontWeightMedium}
  }

  .rdp-day_range_end.rdp-day_range_start {
    background-color: ${colorCoreBlack900Base};
  }

  .rdp:not([dir='rtl'])
    .rdp-day_range_start:not(.rdp-day_range_end)
    .${dayContentClassName},
    .rdp:not([dir='rtl'])
    .rdp-day_range_end:not(.rdp-day_range_start)
    .${dayContentClassName},
    .rdp[dir='rtl']
    .rdp-day_range_start:not(.rdp-day_range_end)
    .${dayContentClassName},
    .rdp[dir='rtl']
    .rdp-day_range_end:not(.rdp-day_range_start)
    .${dayContentClassName} {
    ${dayContentPseudo}
  }

  .rdp-cell:last-child .rdp-day_range_middle {
    border-top-right-radius: ${CORNER_RADIUS.circle};
    border-bottom-right-radius: ${CORNER_RADIUS.circle};
  }

  .rdp-cell:first-child .rdp-day_range_middle {
    border-top-left-radius: ${CORNER_RADIUS.circle};
    border-bottom-left-radius: ${CORNER_RADIUS.circle};
  }

  .rdp-tbody .rdp-row:not(:last-child) {
    border-bottom: 4px solid ${colorCoreWhite1000};
  }

  ${({ isLargeCalendar }) => isLargeCalendar &&
    css `
      .rdp {
        --rdp-cell-size: ${INDENT.xl};

        ${ADAPTIVE.maxWidth.desktop} {
          --rdp-cell-size: ${INDENT.l};
        }

        ${ADAPTIVE.maxWidth.tablet} {
          --rdp-cell-size: ${INDENT.xl};
        }
      }

      .rdp-months {
        padding: ${INDENT.xxs} ${INDENT.xs} ${INDENT.xs} ${INDENT.xs};
        box-shadow: none;
      }

      .rdp-head_cell {
        height: ${INDENT.xl};
      }

      .rdp-cell {
        height: ${INDENT.l};
      }

      .rdp-day,
      .rdp-day_today:not(.rdp-day_outside) {
        margin: ${INDENT.none} ${INDENT.auto};
        max-width: 100%;
        height: 100%;
        border-radius: ${CORNER_RADIUS.m};
      }
    `}

  ${({ isBottomSheetNeeded }) => isBottomSheetNeeded &&
    css `
      ${ADAPTIVE.maxWidth.tablet} {
        .rdp-tbody .rdp-row:not(:last-child) {
          border: none;
        }

        .rdp-month {
          width: 100%;
        }

        .rdp-table {
          max-width: 100%;
          width: 100%;
        }

        .rdp-cell {
          padding: 1px;

          &:first-child,
          &:last-child {
            .rdp-day_range_middle {
              border-radius: ${CORNER_RADIUS.m};
            }
          }
        }

        .rdp-day {
          margin: 0 auto;
          max-width: 100%;
          width: 100%;
          height: 100%;
          border-radius: ${CORNER_RADIUS.m};
        }

        .rdp-day_range_end.rdp-day_range_start {
          border-radius: ${CORNER_RADIUS.m};
        }
      }
    `}
`;
